import React, { Component, Fragment } from 'react';
import { withTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import {
  GelContentColumn,
  GelContentContainer,
  GelContentRow,
  HeroBlock,
  Link,
  List,
  RegularCard,
  withAuthentication
} from "cw-styleguide-react";
import { route } from "../../../routes";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { LANGUAGE_EN, STATUS_AWAITING_AMENDMENTS, STATUS_AWAITING_TRANSLATION } from "../../../constants";
import i18n from "../../../i18n";

class TranslationsLandingView extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('view.translations.landing.title')}</title>
        </Helmet>
        <BreadcrumbsItem to={route('landing')}>
          {this.props.t('view.translations.landing.breadcrumb')}
        </BreadcrumbsItem>
        <GelContentContainer>
          <h1>{this.props.t('view.translations.landing.title')}</h1>
        </GelContentContainer>
        <HeroBlock>
          {this.props.t('view.translations.landing.introduction')}
        </HeroBlock>
        <GelContentContainer>
          <h2>{this.props.t('view.translations.landing.subheading.translationStatus')}</h2>
          <div className='gel-hide-md-only gel-hide-lg-only gel-hide-xl-only'>
            <GelContentRow>
              <GelContentColumn md={4}>
                <h3>{this.props.t('view.translations.landing.subheading.awaitingTranslation')} ({this.props.summary.courses[STATUS_AWAITING_TRANSLATION] + this.props.summary.venues[STATUS_AWAITING_TRANSLATION]})</h3>
                <List styles={['list-large']} items={[
                  <Link to={route('coursesTranslateManage') + "?status=" + STATUS_AWAITING_TRANSLATION}>{this.props.t('misc.courses')} ({this.props.summary.courses[STATUS_AWAITING_TRANSLATION]})</Link>,
                  <Link to={route('venuesTranslateManage') + "?status=" + STATUS_AWAITING_TRANSLATION}>{this.props.t('misc.venues')} ({this.props.summary.venues[STATUS_AWAITING_TRANSLATION]})</Link>
                ]} />
              </GelContentColumn>
              <GelContentColumn md={4}>
                <h3>{this.props.t('view.translations.landing.subheading.awaitingAmendments')} ({this.props.summary.courses[STATUS_AWAITING_AMENDMENTS] + this.props.summary.venues[STATUS_AWAITING_AMENDMENTS]})</h3>
                <List styles={['list-large']} items={[
                  <Link to={route('coursesTranslateManage') + "?status=" + STATUS_AWAITING_AMENDMENTS}>{this.props.t('misc.courses')} ({this.props.summary.courses[STATUS_AWAITING_AMENDMENTS]})</Link>,
                  <Link to={route('venuesTranslateManage') + "?status=" + STATUS_AWAITING_AMENDMENTS}>{this.props.t('misc.venues')} ({this.props.summary.venues[STATUS_AWAITING_AMENDMENTS]})</Link>
                ]} />
              </GelContentColumn>
              <GelContentColumn md={4}>
                <h3>{this.props.t('view.translations.landing.subheading.assignedToMe')} ({this.props.summary.courses['translatorAssigned'] + this.props.summary.venues['translatorAssigned']})</h3>
                <List styles={['list-large']} items={[
                  <Link to={route('coursesTranslateManage') + "?translatorAssigned=" + this.props.authentication.getClaim('atlasId')}>{this.props.t('misc.courses')} ({this.props.summary.courses['translatorAssigned']})</Link>,
                  <Link to={route('venuesTranslateManage') + "?translatorAssigned=" + this.props.authentication.getClaim('atlasId')} >{this.props.t('misc.venues')} ({this.props.summary.venues['translatorAssigned']})</Link>
                ]} />
              </GelContentColumn>
            </GelContentRow>
          </div>
          <div className='gel-hide-sm-up-to'>
            <GelContentRow>
              <GelContentColumn md={4}>
                <h3>{this.props.t('view.translations.landing.subheading.awaitingTranslation')} ({this.props.summary.courses[STATUS_AWAITING_TRANSLATION] + this.props.summary.venues[STATUS_AWAITING_TRANSLATION]})</h3>
              </GelContentColumn>
              <GelContentColumn md={4}>
                <h3>{this.props.t('view.translations.landing.subheading.awaitingAmendments')} ({this.props.summary.courses[STATUS_AWAITING_AMENDMENTS] + this.props.summary.venues[STATUS_AWAITING_AMENDMENTS]})</h3>
              </GelContentColumn>
              <GelContentColumn md={4}>
                <h3>{this.props.t('view.translations.landing.subheading.assignedToMe')} ({this.props.summary.courses['translatorAssigned'] + this.props.summary.venues['translatorAssigned']})</h3>
              </GelContentColumn>
            </GelContentRow>
            <GelContentRow>
              <GelContentColumn md={4}>
                <List styles={['list-large']} items={[
                  <Link to={route('coursesTranslateManage') + "?status=" + STATUS_AWAITING_TRANSLATION}>{this.props.t('misc.courses')} ({this.props.summary.courses[STATUS_AWAITING_TRANSLATION]})</Link>,
                  <Link to={route('venuesTranslateManage') + "?status=" + STATUS_AWAITING_TRANSLATION}>{this.props.t('misc.venues')} ({this.props.summary.venues[STATUS_AWAITING_TRANSLATION]})</Link>
                ]} />
              </GelContentColumn>
              <GelContentColumn md={4}>
                <List styles={['list-large']} items={[
                  <Link to={route('coursesTranslateManage') + "?status=" + STATUS_AWAITING_AMENDMENTS}>{this.props.t('misc.courses')} ({this.props.summary.courses[STATUS_AWAITING_AMENDMENTS]})</Link>,
                  <Link to={route('venuesTranslateManage') + "?status=" + STATUS_AWAITING_AMENDMENTS}>{this.props.t('misc.venues')} ({this.props.summary.venues[STATUS_AWAITING_AMENDMENTS]})</Link>
                ]} />
              </GelContentColumn>
              <GelContentColumn md={4}>
                <List styles={['list-large']} items={[
                  <Link to={route('coursesTranslateManage') + "?translatorAssigned=" + this.props.authentication.getClaim('atlasId')}>{this.props.t('misc.courses')} ({this.props.summary.courses['translatorAssigned']})</Link>,
                  <Link to={route('venuesTranslateManage') + "?translatorAssigned=" + this.props.authentication.getClaim('atlasId')} >{this.props.t('misc.venues')} ({this.props.summary.venues['translatorAssigned']})</Link>
                ]} />
              </GelContentColumn>
            </GelContentRow>
          </div>
          <GelContentRow>
            <RegularCard width={33} link={{ to: route('coursesTranslateManage') }} title={this.props.t('view.translations.courses.title')} source={'https://cwimagestorage.blob.core.windows.net/courses/prod/images/thumbnail_courses_manage_courses.jpg'} alt={this.props.t('view.translations.courses.title')}>
              {this.props.t('view.translations.courses.teaser')}
            </RegularCard>
            <RegularCard width={33} link={{ to: route('venuesTranslateManage') }} title={this.props.t('view.translations.venues.title')} source={'https://cwimagestorage.blob.core.windows.net/courses/prod/images/thumbnail_courses_manage_venues.jpg'} alt={this.props.t('view.translations.venues.title')}>
              {this.props.t('view.translations.venues.teaser')}
            </RegularCard>

            <RegularCard width={33} link={{ to: (i18n.language === LANGUAGE_EN ? process.env.REACT_APP_BASEURL_EN : process.env.REACT_APP_BASEURL_CY) + this.props.t('view.support.manage.url') }} title={this.props.t('view.support.manage.title')} source={'https://cwimagestorage.blob.core.windows.net/courses/prod/images/thumbnail_courses_courses_support_centre.jpg'} alt={this.props.t('view.providers.support.title')}>
              {this.props.t('view.support.manage.teaser')}
            </RegularCard>

          </GelContentRow>
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withAuthentication(withTranslation('local')(TranslationsLandingView));
